<template>
  <Transition name="slide">
    <div
      v-if="open"
      class="fixed top-0 right-0 bg-white border-l border-gray-200 w-screen md:w-1/2 h-screen z-20"
    >
      <div class="flex justify-between py-2 px-4">
        <Link :href="navData.rootPath" class="md:hidden">
          <EmmalagatLogo :size="32" class="cursor-pointer" />
        </Link>
        <div class="grow"></div>
        <button
          class="text-lg content-center cursor-pointer"
          @click="$emit('close')"
        >
          <PhX :size="24" />
        </button>
      </div>

      <hr class="m-4 h-px border-0 bg-gray-200" />

      <div class="py-4 px-4 text-lg flex flex-col gap-4">
        <Link
          :href="navData.recipesPath"
          class="flex gap-3 font-semibold hover:text-emerald-600"
        >
          <PhHamburger :size="24" class="self-center" />
          Alla recept
        </Link>

        <Link
          :href="navData.doughCalculatorPath"
          class="flex gap-3 font-semibold hover:text-emerald-600"
        >
          <PhCalculator :size="24" class="self-center" />
          Degkalkylator
        </Link>

        <Link
          :href="navData.tastingMenusPath"
          class="flex gap-3 font-semibold hover:text-emerald-600"
        >
          <PhForkKnife :size="24" class="self-center" />
          Avsmakningsmenyer
        </Link>

        <template v-if="navData.currentUser">
          <Link
            v-if="navData.currentUser.admin"
            :href="navData.categoriesPath"
            class="flex gap-3 font-semibold hover:text-emerald-600"
          >
            <PhCalendarBlank :size="24" class="self-center" />
            Kategorier
          </Link>

          <Link
            v-if="navData.currentUser.admin"
            :href="navData.adminTechniquesPath"
            class="flex gap-3 font-semibold hover:text-emerald-600"
          >
            <PhCalendarBlank :size="24" class="self-center" />
            Tekniker (admin)
          </Link>

          <div class="text-center mt-4">
            <form :action="navData.currentUser.sessionPath" method="post">
              <input type="hidden" name="_method" value="delete" />
              <input
                type="hidden"
                name="authenticity_token"
                :value="csrfToken"
              />
              <button type="submit" class="cursor-pointer">Logout</button>
            </form>
          </div>
        </template>

        <template v-else>
          <Link
            :href="navData.newSessionPath"
            class="hover:text-emerald-600"
            @click="$emit('close')"
            >Login</Link
          >
        </template>
      </div>
    </div>
  </Transition>

  <!-- Backdrop -->
  <Transition name="fade">
    <div
      v-if="open"
      class="fixed inset-0 bg-black/30 z-10"
      @click="$emit('close')"
    ></div>
  </Transition>
</template>

<script setup>
import {
  PhX,
  PhHamburger,
  PhCalendarBlank,
  PhCalculator,
  PhForkKnife,
} from "@phosphor-icons/vue";
import { Link } from "@inertiajs/vue3";
import EmmalagatLogo from "@/components/icons/EmmalagatLogo.vue";

defineProps({
  open: { type: Boolean, required: true },
  navData: { type: Object, required: true },
  csrfToken: { type: String, default: "" },
});

defineEmits(["close"]);
</script>

<style scoped>
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.25s ease;
}
.slide-enter-from,
.slide-leave-to {
  transform: translateX(100%);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
